"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $spinnerContainer = document.querySelector('.spinner-container');
exports.default = {
    display: function () {
        $spinnerContainer.style.display = 'block';
    },
    hide: function () {
        $spinnerContainer.style.display = 'none';
    }
};
